
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"3.75","y":"3.75","width":"6.5","height":"6.5","rx":"1.25","stroke":"#989AB2","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"13.75","y":"3.75","width":"6.5","height":"6.5","rx":"1.25","stroke":"#989AB2","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"3.75","y":"13.75","width":"6.5","height":"6.5","rx":"1.25","stroke":"#989AB2","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17 15v4M19 17h-4","stroke":"#989AB2","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    